/** Company access codes are case-insensitive join keys (e.g. TESTONBOARD2026). */
export function normalizeAccessCode(code: string | null | undefined): string {
  if (typeof code !== 'string') return '';
  return code.replace(/\s+/g, '').toUpperCase();
}
